(function ($, Drupal) {

  jQuery(document).ready(function ($) {
    if ($('.flexslider.home-banner').length) {
      $('.flexslider.home-banner').flexslider({
        animation: "slide"
      });
    }

    if ($('.view-filters').length) {
      $('.view-filters fieldset legend').click(function () {
        if ($(this).parent().hasClass('on')) {
          $(this).parent().removeClass('on');
        } else {
          $(this).parent().addClass('on');
        }
      })
    }

    $('#block-mainnavigation-menu').click(function () {
      if ($('nav.menu--main').hasClass('active')) {
        $('nav.menu--main').removeClass('active');
      } else {
        $('nav.menu--main').addClass('active');
      }
    })
    $('nav.menu--main .menu-item--expanded > span').click(function () {
      if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active');
      } else {
        $(this).parent().addClass('active');
      }
    })
  })

})(jQuery, Drupal);
